// /assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput
 * @property {HTMLElement} characterCount
 */

class ProductCustomProperty extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.handleVariantSelection = (event) => {
      const target = event.target;

      if (
        target instanceof HTMLInputElement ||
        target instanceof HTMLSelectElement
      ) {
        window.requestAnimationFrame(() => this.updateVisibility());
      }
    };

    document.addEventListener('change', this.handleVariantSelection);
    this.updateVisibility();
  }

  disconnectedCallback() {
    document.removeEventListener('change', this.handleVariantSelection);
    super.disconnectedCallback();
  }

  handleInput() {
    this.updateCharacterCount();
  }

  updateVisibility() {
    const selectedControls = document.querySelectorAll(
      'input[type="radio"]:checked, select'
    );

    const personalizationSelected = Array.from(selectedControls).some(
      (control) =>
        control.value
          ?.trim()
          .toLowerCase()
          .includes('mit personalisierung')
    );

    this.hidden = !personalizationSelected;
    this.style.display = personalizationSelected ? '' : 'none';

    const input = this.refs.textInput;

    if (!input) return;

    input.required = personalizationSelected;
    input.setAttribute(
      'aria-required',
      personalizationSelected ? 'true' : 'false'
    );

    if (!personalizationSelected) {
      input.value = '';
      this.updateCharacterCount();
    }
  }

  updateCharacterCount() {
    const { characterCount, textInput } = this.refs;

    if (!characterCount || !textInput) return;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    characterCount.textContent = template
      .replace('[current]', String(textInput.value.length))
      .replace('[max]', String(textInput.maxLength));
  }
}

customElements.define(
  'product-custom-property-component',
  ProductCustomProperty
);